import * as React from 'react';
import type { Dispatch, SetStateAction } from 'react';

import type { SectionName } from 'bundles/expression-of-interest/components/EoiDialog';
import type { ActionTypes } from 'bundles/expression-of-interest/types';

export type DegreeDescriptionEoiStateContextType = {
  hasCompletedEoi: boolean;
  setHasCompletedEoi: Dispatch<SetStateAction<boolean>>;
  isQualified: boolean;
  setIsQualified: Dispatch<SetStateAction<boolean>>;
  hasCompletedQQForm: boolean;
  setHasCompletedQQForm: Dispatch<SetStateAction<boolean>>;
  loadingQQUserData: boolean;
  setLoadingQQUserData: Dispatch<SetStateAction<boolean>>;
  highestEducation?: number | null;
  setHighestEducation: Dispatch<SetStateAction<number | null | undefined>>;
  learnerTimeline?: number | null;
  setLearnerTimeline: Dispatch<SetStateAction<number | null | undefined>>;
  financePlan?: number | null;
  setFinancePlan: Dispatch<SetStateAction<number | null | undefined>>;
  eoiButtonsToUse: ActionTypes[];
  initialSection?: SectionName;
  setInitialSection: Dispatch<SetStateAction<SectionName | undefined>>;
};

export const DegreeDescriptionEoiStateContext = React.createContext<DegreeDescriptionEoiStateContextType | undefined>(
  undefined
);

export const useDegreeDescriptionEoiStateContext = () => {
  const context = React.useContext(DegreeDescriptionEoiStateContext);
  if (!context)
    throw new Error('useDegreeDescriptionEoiStateContext was used outside of DegreeDescriptionEoiStateContext');
  return context;
};

export default DegreeDescriptionEoiStateContext;
